var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('input',{staticClass:"w-full rounded-md border-2 focus:outline-none text-sm px-3 py-2",class:_vm.warning ? 'border-red-500 focus:border-red-600' : 'border-gray-300 focus:border-blue-800',attrs:{"placeholder":_vm.placeholder,"type":"text"},domProps:{"value":_vm.filterValue(_vm.value)},on:{"input":_vm.handleInput}})])
}
var staticRenderFns = []

export { render, staticRenderFns }